import { createConfigurable } from '@peloton/config-singleton/createConfigurable';

export const { config, updateConfig } = createConfigurable({
  libraryPageSize: 18,
});
